import thunk from 'redux-thunk'
import createSagaMiddleware from 'redux-saga'
import { createStore, applyMiddleware, compose } from 'redux'

import rootReducer from './reducers'
import config from './config'

var store

const initialState = {
  info: { language: config.defaultLanguage },
  portal: {},
}

export const saga = createSagaMiddleware()

const middlewares = [thunk, saga]

export const createReduxStore = () => {
  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose
  store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middlewares)),
  )

  return store
}

export const getStore = () => store



// WEBPACK FOOTER //
// ./src/store.js